import { Component, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Router, RouterLink } from "@angular/router";

import { ActionButtonComponent } from "../shared/action-button/action-button.component";
import { ApiService } from "src/app/api.service";

@Component({
	selector: "app-forgot",
	templateUrl: "./forgot.component.html",
	styleUrls: ["./forgot.component.scss"],
	imports: [FormsModule, ActionButtonComponent, RouterLink]
})
export class ForgotComponent {
	router = inject(Router);
	private api = inject(ApiService);

	public email = "";

	public success = false;

	async Forgot() {
		this.success = false;
		try {
			await this.api.ForgotPassword(this.email);
			this.success = true;
		} catch (err) {
			if (err?.status === 400) {
				throw new Error("Email required", { cause: err });
			} else if (err?.status === 429) {
				throw new Error("Too many forgot password attempts. Please wait 15 minutes and try again.", { cause: err });
			} else {
				throw new Error("Forgot password failed", { cause: err });
			}
		}
	}
}
